/**
 * 定義對資料做的動作。
 */
export enum DataAction {
  NEW = 'new',
  EDIT = 'edit',
  VIEW = 'view',
  DELETE = 'delete',
  DISCARD = 'discard'
}
